/* eslint-disable no-nested-ternary */
/* eslint-disable no-bitwise */
import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import LucideIcon from './LucideIcon';

// Fonction utilitaire pour convertir une couleur hexadécimale en RGBA avec opacité
const hexToRgba = (hex, opacity) => {
    const bigint = parseInt(hex.replace('#', ''), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

// Composant ButtonBox
const CustomTag = ({ text, textColor, type, tooltipMessage, tooltipIcon }) => {
    const error = '#8F0000'
    const success = '#008F24'
    const warning = '#eab81b'
    const defaultColor = '#5E17EB'
    // eslint-disable-next-line no-unneeded-ternary
    const color = textColor ? textColor : type === 'success' ? success : type === 'error' ? error : type === 'warning' ? warning : defaultColor
    const backgroundColor = textColor ? hexToRgba(textColor, 0.1) : hexToRgba(type === 'success' ? success : type === 'error' ? error : type === 'warning' ? warning : defaultColor, 0.1); // Couleur de fond avec opacité

    return (
        <Stack
            direction={'row'}
            alignItems={'center'}
            spacing={0.5}
            component="button"
            padding={0.5}
            paddingX={1}
            color={color}
            sx={{
                borderRadius: '35px',
                fontSize: 10,
                bgcolor: backgroundColor,
                border: `1px solid ${backgroundColor}`,
            }}
        >

            <Typography sx={{ fontSize: 10, }} variant='caption'> <strong>{text}</strong></Typography>
            {
                tooltipIcon && <Tooltip title={tooltipMessage || 'Informations'} arrow>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                    <LucideIcon name={tooltipIcon} size={12} />
                </span>
            </Tooltip>
            }
            
        </Stack>
    );
};

export default CustomTag;